export interface OnfidoProfile {
    attachedUsers: [OnfidoUser];
}

export interface AriadnextProfile {
    attachedUsers: [AriadnextUser];
}

export interface AriadnextUser {
    applicantId: string;
    userId: number;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    createDateTime: string;
    lastUpdateDateTime: string;
    verificationAttempts: number;
    errorReason: string;
    lastAriadnextStatus: AriadVerificationStatus;
    documentReportCode: string;
    selfieReportCode: string;
    expired: boolean;
    checks: [AriadnextUserCheck];
}

export interface AriadnextUserCheck {
    checkId: string;
    ariadnextStatus: AriadVerificationStatus;
    notificationLink: string;
    validationErrorReason: string;
    sendLinkApproach: string;
    sendDateTime: string;
}

export interface OnfidoUser {
    applicantId: string;
    createDateTime: string;
    userName: string;
    email: string;
    onfidoStatus: OnfidoVerificationStatus;
    checks: [OnfidoCheck];
}

export interface OnfidoCheck {
    checkId: string;
    createTime: string;
    completeTime: string;
    hasErrors: boolean;
    reports: [OnfidoReport];
}

export interface OnfidoReport {
    id: string;
    name: string;
    createdAt: string;
    href: string;
    breakdown: BreakDown;
}

export interface BreakDown {
    face_comparison: BreakDownResult;
    face_match: BreakDownResult;
    image_integrity: BreakDownResult;
    face_detected: BreakDownResult;
    visual_authenticity: BreakDownResult;
    liveness_detected: BreakDownResult;
    spoofing_detection: BreakDownResult;
    compromised_document: BreakDownResult;
    data_comparison: BreakDownResult;
    issuing_country: BreakDownResult;
    gender: BreakDownResult;
    date_of_expiry: BreakDownResult;
    last_name: BreakDownResult;
    document_type: BreakDownResult;
    document_numbers: BreakDownResult;
    first_name: BreakDownResult;
    date_of_birth: BreakDownResult;
    data_consistency: BreakDownResult;
    nationality: BreakDownResult;
    data_validation: BreakDownResult;
    document_expiration: BreakDownResult;
    expiry_date: BreakDownResult;
    mrz: BreakDownResult;
    fonts: BreakDownResult;
    picture_face_integrity: BreakDownResult;
    template: BreakDownResult;
    security_features: BreakDownResult;
    original_document_present: BreakDownResult;
    digital_tampering: BreakDownResult;
    other: BreakDownResult;
    face_detection: BreakDownResult;
    image_quality: BreakDownResult;
    supported_document: BreakDownResult;
    colour_picture: BreakDownResult;
    police_record: BreakDownResult;
}

export interface BreakDownResult {
    result: string;
    breakdown: BreakDown;
}

export enum OnfidoVerificationStatus {
    INVALID = 'INVALID',
    OPEN_TO_UPLOAD_DATA = 'OPEN_TO_UPLOAD_DATA',
    IN_PROGRESS = 'IN_PROGRESS',
    VERIFIED = 'VERIFIED',
    DECLINED = 'DECLINED',
    OUT_OF_VERIFICATION = 'OUT_OF_VERIFICATION',
    CONSIDER = 'CONSIDER'
}

export enum AriadVerificationStatus {
    NONE = 'NONE',
    OBSOLETE = 'OBSOLETE',
    WARN = 'WARN',
    ERROR = 'ERROR',
    OK = 'OK',
    OUT_OF_VERIFICATION = 'OUT_OF_VERIFICATION'
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/entity/identity-verification.ts